export const getDivisionAbbr = (abbr) => {
    if (abbr === 'TBB') {
        return 'WBABCOM';
    }

    return abbr || 'Unknown';
}


// WEBPACK FOOTER //
// ./src/modules/Leads/utils/getDivisionAbbr.js